import React, { useRef, useState } from "react";
import { Col, Container, Row, Button, Image } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import banner from "../../Assets/images/home/banner_lap.webp";
import bannerMobileView from "../../Assets/images/home/mobile-banner.webp";

import { LazyLoadImage } from "react-lazy-load-image-component";
import jckBannerImg from '../../Assets/images/home/ai-banner-img/jck-2025-img.webp'
import EngRingBnannerImg from '../../Assets/images/home/ai-banner-img/eng-ring-banner.png'
import smartProducts from "../../Assets/images/home/ai-banner-img/home-geng-gif.gif";
import Genrative from "../../Assets/images/home/ai-banner-img/home-dimond-brecelate.gif";
import CreateImg from "../../Assets/images/home/ai-banner-img/home-create-banner.gif";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

import '../../Assets/css/newJckHomeBanner.css'
const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop);

const Banner = () => {
  const myRef = useRef(null);
  const executeScroll = () => scrollToRef(myRef);
  const history = useHistory();
const [isLoading, setIsLoading] = useState(true);
  const handleImageLoad = () => {
    setIsLoading(false);
  };

  // function handleClick() {
  //   history.push("/diamond-jewelry-web-development");
  // }

  const [value, setValue] = useState('1');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <section className="bw_banner_section">
        <Container className="bw_custome_container_banner">
          <div className="bw_banner_content">
            <Row className="w-100 m-auto">
              <Col
               xl={6}
                lg={6}
                md={12}
                xs={12}
                className="p-sm-0 p-0 p-md-0 p-lg-0 p-xl-auto d-flex align-items-center"
              >
                <div className="bw_banner_content_inner">
                  <Image src={jckBannerImg} className="jck_banner_img_home"  />
                  <h1>
                    {/* Let’s Eliminate The{" "}
                    <strong>
                      Physical <span>Barrier </span>
                    </strong>{" "}
                    Between You & Your Customers{" "} */}

                    Grow Your <br />
                    Jewelry Business  <br />
                    <span className="home_banner_text_color_ai">with the Power of AI</span>

                  </h1>
                  <p>
                    At Belgium WebNet, we use the Newest AI Tools and methods to increase
                    the Sales, Engagement, and Visibility of your Brand. Take your company
                    to the next level using technology.
                  </p>
                  <div className="bw_btb_border_white">
                    <button
                      // className="bw_custom_btn"
                      className="btn_outline_white"
                      onClick={() => history.push('/ai-features')}
                    >
                     Know More
                    </button>
                  </div>
                </div>
              </Col>
              <Col sm={12} md={12} xs={12} lg={6} className="">
                <div className="bw_Ai_genrated_heading_box">
                  <div className="text-center">

                    <h2>AI Generated</h2>
                  </div>

                  <TabContext value={value}>
                    <Box sx={{ borderBottom: 0, borderColor: 'divider' }}>
                    <TabList onChange={handleChange} centered aria-label="lab API tabs example" className="ai_banner_tab_list">
                      <Tab label="Product Description" value="1" className="ai_banner_tab_btn" />
                      <Tab label="SEO Meta Title & Description" className="ai_banner_tab_btn" value="2" />
                      <Tab label="Media & Images" className="ai_banner_tab_btn" value="3" />
                    </TabList>
                    </Box>
                    <TabPanel value="1">
                      <div className="ai_banner_tab_content">
                         
                 {/* {(isLoading && (
                  <div className="skeleton1" style={{ height: "440px" }}></div>
                ))} */}
                  <Image src={smartProducts} className="ai_banner_tab_img_home" 
                //    style={{
                //   display: isLoading ? "none" : "block",
                //   width: "100%",
                //   height: "100%",
                // }}
                  // onLoad={handleImageLoad}
                  />
                      </div>
                    </TabPanel>
                    <TabPanel value="2">
                       <div className="ai_banner_tab_content">
<Image src={Genrative} className="ai_banner_tab_img_home" />
                      </div>
                    </TabPanel>
                    <TabPanel value="3">
                       <div className="ai_banner_tab_content">
<Image src={CreateImg} className="ai_banner_tab_img_home" />
                      </div>
                    </TabPanel>
                  </TabContext>

                </div>
              </Col>
              {/* <Col lg={6} md={10} xs={12} className="m-md-auto">
                <div className="bw_banner_img_main position-relative">
                  <LazyLoadImage
                    src={EngRingBnannerImg}
                    alt="banner img"
                    className="bw_banner_image_desktopview"
                  />
                  <LazyLoadImage
                    src={bannerMobileView}
                    alt="banner img Mobile View"
                    className="bw_banner_mobile_view"
                  />
                </div>
              </Col> */}
            </Row>
          </div>
          <div className="bw_scroll_sec">
            <div className="bw_scroll-down" onClick={executeScroll}></div>
            <p>Scroll to explore</p>
          </div>
        </Container>
      </section>


      <div ref={myRef}></div>
    </>
  );
};

export default React.memo(Banner);
